import { useAuth } from '../../context/AuthContext';
import { useLang } from '../../context/LangContext';
import { COLORS } from '../../lib/constants';

export default function ProfilePage() {
  const { profile, signOut } = useAuth();
  const { isRtl, toggleLang, lang } = useLang();

  const MENU = [
    { icon: '🌐', labelAr: `اللغة: ${lang === 'ar' ? 'العربية' : 'English'}`, labelEn: `Language: ${lang === 'ar' ? 'Arabic' : 'English'}`, action: toggleLang },
    { icon: '🔔', labelAr: 'الإشعارات', labelEn: 'Notifications', action: null },
    { icon: '🔒', labelAr: 'الخصوصية', labelEn: 'Privacy', action: null },
    { icon: '💬', labelAr: 'الدعم — JADWILAPP', labelEn: 'Support — JADWILAPP', action: () => window.open('https://wa.me/966500748456', '_blank'), green: true },
    { icon: '❓', labelAr: 'المساعدة', labelEn: 'Help', action: null },
    { icon: '🚪', labelAr: 'تسجيل الخروج', labelEn: 'Logout', action: signOut, red: true },
  ];

  return (
    <div style={{ background: COLORS.bg, minHeight: '100vh', fontFamily: 'Cairo, sans-serif', direction: isRtl ? 'rtl' : 'ltr', paddingBottom: 80 }}>
      <div style={{ background: `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.primaryDark})`, padding: '28px 20px 24px', color: '#fff', textAlign: 'center' }}>
        <div style={{ width: 72, height: 72, borderRadius: '50%', background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32, margin: '0 auto 12px' }}>👤</div>
        <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 4 }}>{profile && profile.full_name}</div>
        <div style={{ fontSize: 13, opacity: 0.8 }}>{profile && profile.phone || ''}</div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 28, marginTop: 16 }}>
          {[
            { num: (profile && profile.bookings_count) || 0, labelAr: 'حجوزات', labelEn: 'Bookings' },
            { num: (profile && profile.points) || 0, labelAr: 'نقطة', labelEn: 'Points' }
          ].map((s, i) => (
            <div key={i} style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 20, fontWeight: 900 }}>{s.num}</div>
              <div style={{ fontSize: 11, opacity: 0.8 }}>{isRtl ? s.labelAr : s.labelEn}</div>
            </div>
          ))}
        </div>
      </div>
      <div style={{ padding: 16 }}>
        <div style={{ background: '#fff', borderRadius: 16, overflow: 'hidden', border: `1px solid ${COLORS.border}` }}>
          {MENU.map((item, i) => (
            <div key={i} onClick={item.action} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '15px 16px', borderBottom: i < MENU.length - 1 ? `1px solid ${COLORS.border}` : 'none', cursor: item.action ? 'pointer' : 'default', opacity: item.action ? 1 : 0.5 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ fontSize: 20 }}>{item.icon}</span>
                <span style={{ fontSize: 14, fontWeight: 600, color: item.red ? COLORS.error : item.green ? '#2E7D32' : COLORS.text }}>
                  {isRtl ? item.labelAr : item.labelEn}
                </span>
              </div>
              {item.action && !item.red && <span style={{ color: COLORS.textMuted }}>{isRtl ? '‹' : '›'}</span>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
